var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficAccident = function SvgLiveTrafficAccident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D82F24",
    d: "M12 22.155c5.564 0 10.075-4.511 10.075-10.076 0-5.564-4.51-10.075-10.075-10.075-5.564 0-10.075 4.511-10.075 10.076 0 5.564 4.51 10.074 10.075 10.074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.235 15.318h3.868s.585-2.528 2.708-2.528c2.887 0 3.058 2.528 3.058 2.528h2.933s1.241-4.31-2.087-4.31h-3.328L9.814 8.302H5.235s-2.708 3.068 0 7.017"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.081 17.135a2.042 2.042 0 1 0 0-4.084 2.042 2.042 0 0 0 0 4.084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.34,
    d: "m13.835 9.435-.639-2.645 2.276 1.916L17.46 6.61l-.467 2.555 2.465-.36-1.449 1.871"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D82F24",
    d: "M7.322 8.922v2.384h4.192L9.301 8.922z"
  })));
};
export default SvgLiveTrafficAccident;